function DINameAddress({ org }) {
  return (
    <div className="cb-margin-bottom-16">
      <div className="cb-h5">
        {org.name} ({org.dicode})
      </div>
      <div>{org.address}</div>
      <div>
        {org.city}, {org.state || org.country} {org.zip || org.postal}
      </div>
    </div>
  )
}

export default DINameAddress
